const middleware = {}

middleware['activation'] = require('../../../src/middleware/activation.js')
middleware['activation'] = middleware['activation'].default || middleware['activation']

middleware['allowUnpaidAppAuthTokens'] = require('../../../src/middleware/allowUnpaidAppAuthTokens.ts')
middleware['allowUnpaidAppAuthTokens'] = middleware['allowUnpaidAppAuthTokens'].default || middleware['allowUnpaidAppAuthTokens']

middleware['applicationRedirects'] = require('../../../src/middleware/applicationRedirects.ts')
middleware['applicationRedirects'] = middleware['applicationRedirects'].default || middleware['applicationRedirects']

middleware['auth'] = require('../../../src/middleware/auth.ts')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['checkForAppUpdatesMiddleware'] = require('../../../src/middleware/checkForAppUpdatesMiddleware.ts')
middleware['checkForAppUpdatesMiddleware'] = middleware['checkForAppUpdatesMiddleware'].default || middleware['checkForAppUpdatesMiddleware']

middleware['featureLogging'] = require('../../../src/middleware/featureLogging.ts')
middleware['featureLogging'] = middleware['featureLogging'].default || middleware['featureLogging']

middleware['handleOnboardingRouting'] = require('../../../src/middleware/handleOnboardingRouting.ts')
middleware['handleOnboardingRouting'] = middleware['handleOnboardingRouting'].default || middleware['handleOnboardingRouting']

middleware['hooks/useMiddlewareContext'] = require('../../../src/middleware/hooks/useMiddlewareContext.ts')
middleware['hooks/useMiddlewareContext'] = middleware['hooks/useMiddlewareContext'].default || middleware['hooks/useMiddlewareContext']

middleware['index'] = require('../../../src/middleware/index.ts')
middleware['index'] = middleware['index'].default || middleware['index']

middleware['non-paid'] = require('../../../src/middleware/non-paid.js')
middleware['non-paid'] = middleware['non-paid'].default || middleware['non-paid']

middleware['password-reset'] = require('../../../src/middleware/password-reset.js')
middleware['password-reset'] = middleware['password-reset'].default || middleware['password-reset']

middleware['redirect-if-paid'] = require('../../../src/middleware/redirect-if-paid.js')
middleware['redirect-if-paid'] = middleware['redirect-if-paid'].default || middleware['redirect-if-paid']

middleware['redirectFromOnboardingWizard'] = require('../../../src/middleware/redirectFromOnboardingWizard.js')
middleware['redirectFromOnboardingWizard'] = middleware['redirectFromOnboardingWizard'].default || middleware['redirectFromOnboardingWizard']

middleware['redirectIfDelinquent'] = require('../../../src/middleware/redirectIfDelinquent.js')
middleware['redirectIfDelinquent'] = middleware['redirectIfDelinquent'].default || middleware['redirectIfDelinquent']

middleware['redirectLiteToUpgradePages'] = require('../../../src/middleware/redirectLiteToUpgradePages.js')
middleware['redirectLiteToUpgradePages'] = middleware['redirectLiteToUpgradePages'].default || middleware['redirectLiteToUpgradePages']

middleware['redirectRequestsToGuidance'] = require('../../../src/middleware/redirectRequestsToGuidance.js')
middleware['redirectRequestsToGuidance'] = middleware['redirectRequestsToGuidance'].default || middleware['redirectRequestsToGuidance']

middleware['redirectToOnboardingWizard'] = require('../../../src/middleware/redirectToOnboardingWizard.js')
middleware['redirectToOnboardingWizard'] = middleware['redirectToOnboardingWizard'].default || middleware['redirectToOnboardingWizard']

middleware['termsOfServiceNotification'] = require('../../../src/middleware/termsOfServiceNotification.js')
middleware['termsOfServiceNotification'] = middleware['termsOfServiceNotification'].default || middleware['termsOfServiceNotification']

export default middleware
